import { Typography, Paper } from '@mui/material';

export const Home = () => {
  return (
    <Paper elevation={3} style={{ padding: '20px', margin: '20px', textAlign: 'center' }}>
      <Typography variant="h4">Welcome to the Home Page</Typography>
      <Typography variant="body1">This page uses MUI styling and will be used for showing the home content.</Typography>
    </Paper>
  )
}